import { checkPermission } from '@/utils/permission'

import { useUserInfoState } from '@/use/biz/use-userInfo'
import { checkSetting } from '@/utils/setting'
import { UserInfoState } from '@/layout/types'
import { Ref } from '@vue/composition-api'

export const useAuth = () => {
  const userInfoState = useUserInfoState() as Ref<UserInfoState>
  return {
    checkPermission: (privilege: string | string[]) => {
      return checkPermission(privilege, userInfoState.value.privilege)
    },
    checkSetting: (setting: string | string[]) => {
      return checkSetting(userInfoState.value.setting, setting)
    },
  }
}
